// extracted by mini-css-extract-plugin
export default {"container":"Referencial_container__30b+d","conteudo":"Referencial_conteudo__bzVRL"};